export default __webpack_public_path__ + "static/media/284.9fb204b5.png";